/**
 * Marca pública FOOD PLAN (paridad con /gym/{slug}).
 * Path canónico: /food — /food-plan se mantiene por compatibilidad.
 */
import {
  applyDocumentFavicon,
  applyDocumentTitle,
  resetDocumentFavicon,
} from './documentBrand';

export const FOOD_PUBLIC_SLUG = 'food';
export const FOOD_PUBLIC_BASE = '/food';
export const FOOD_LEGACY_BASE = '/food-plan';
export const FOOD_BRAND_NAME = 'FOOD PLAN';
export const FOOD_FAVICON_HREF = '/food-favicon.jpg';
export const FOOD_LOGO_HREF = '/food-logo.jpg';
export const FOOD_APPLE_TOUCH_HREF = '/food-apple-touch.jpg';
export const FOOD_PRIMARY = '#64ba30';
export const FOOD_SECONDARY = '#4d9424';

export function isFoodPublicPath(pathname = '') {
  const p = String(pathname || '');
  return p === FOOD_PUBLIC_BASE
    || p.startsWith(`${FOOD_PUBLIC_BASE}/`)
    || p === FOOD_LEGACY_BASE
    || p.startsWith(`${FOOD_LEGACY_BASE}/`);
}

/** Basename del BrowserRouter Food según URL actual. */
export function resolveFoodBasename(pathname = '') {
  const p = String(pathname || '');
  if (p === FOOD_LEGACY_BASE || p.startsWith(`${FOOD_LEGACY_BASE}/`)) {
    return FOOD_LEGACY_BASE;
  }
  return FOOD_PUBLIC_BASE;
}

export function foodBrandPayload() {
  return {
    brand_name: FOOD_BRAND_NAME,
    brand_slug: FOOD_PUBLIC_SLUG,
    logo_url: FOOD_LOGO_HREF,
    favicon_url: FOOD_FAVICON_HREF,
    primary_color: FOOD_PRIMARY,
    secondary_color: FOOD_SECONDARY,
  };
}

/** Favicon + título Food (pestaña / acceso rápido). No usa API gym. */
export function applyFoodDocumentBrand() {
  if (typeof document === 'undefined') return () => {};
  applyDocumentFavicon(FOOD_FAVICON_HREF, foodBrandPayload());
  const clearTitle = applyDocumentTitle(FOOD_BRAND_NAME);
  const apple = document.querySelector('link[rel="apple-touch-icon"]');
  if (apple) apple.setAttribute('href', FOOD_APPLE_TOUCH_HREF);
  return () => {
    if (typeof clearTitle === 'function') clearTitle();
  };
}

export function resetFoodDocumentBrand() {
  resetDocumentFavicon();
}
